import { axiosInstance } from "api/services/axiosInstance";
import {
  PROJECT_URL,
  ORDER_CODE_URL,
  MARKETPLACE_URL,
} from "constants/ApiConstants";

const orderApi = {
  validateOrder: (projectId, order) =>
    axiosInstance.post(`${PROJECT_URL}/${projectId}/order/validate`, order),
  createOrder: (projectId, order) =>
    axiosInstance.post(`${PROJECT_URL}/${projectId}/order`, order),
  updateOrder: (projectId, eversion, data) =>
    axiosInstance.put(
      `${PROJECT_URL}/${projectId}/order?eversion=${eversion}`,
      data
    ),
  getOrderByCode: (orderCode) =>
    axiosInstance.get(`${ORDER_CODE_URL}/${orderCode}`),
  forwardOrderStatus: (data) =>
    axiosInstance.put(`${PROJECT_URL}/order/forwardChangeOrderStatus`, data),
  reverseOrderStatus: (data) =>
    axiosInstance.put(`${PROJECT_URL}/order/reverseChangeOrderStatus`, data),
  cancelOrder: (projectId, orderId, eversion) =>
    axiosInstance.put(
      `${PROJECT_URL}/${projectId}/order/${orderId}/cancel?eversion=${eversion}`
    ),
  deleteDraftOrder: (projectId, orderId) =>
    axiosInstance.delete(`${PROJECT_URL}/${projectId}/order/${orderId}`),
  getAttachment: (id) =>
    axiosInstance.get(`api/Attachments/GetAttachments/`, {
      params: { id },
    }),
  saveOrderPrerequisites: (projectId, orderId, data) =>
    axiosInstance.post(
      `${PROJECT_URL}/${projectId}/order/${orderId}/SaveOrderPrerequisites`,
      data
    ),
  setListOfOrdersAsSold: (data) =>
    axiosInstance.put(`SetListOfOrdersAsSold`, data),
  createOrderNotes: (orderId, note) =>
    axiosInstance.post(`${MARKETPLACE_URL}/order/CreateOrderNote/${orderId}`, {
      note,
    }),
  updateOrderNote: (orderNoteId, note) =>
    axiosInstance.put(
      `${MARKETPLACE_URL}/order/UpdateOrderNote/${orderNoteId}`,
      {
        note,
      }
    ),
  deleteOrderNote: (orderNoteId) =>
    axiosInstance.delete(
      `${MARKETPLACE_URL}/order/DeleteOrderNote/${orderNoteId}`
    ),
};

export default orderApi;
